import { List, Record } from 'immutable';

export const TopTalent = Record({
  talent_id: 0,
  talent_name: '',
  result_description: '',
  quadrant: null,
  usage_stats: null
});

export const TeamTopTalents = Record({
  never: List(),
  always: List(),
  isPending: false,
  error: null
});